// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3tS6D","fileBtn":"File_fileBtn__3eHDg","closeBtn":"File_closeBtn__3qItO","fileSelected":"File_fileSelected__2HBoh","disabled":"File_disabled__261tr"};